import {
  Layout,
  Col,
  Row,
  Input,
  Image,
  Avatar,
  Divider,
  Space,
  Typography,
  Dropdown,
  Menu,
  Grid,
  InputRef,
  Button,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import logo from "@assets/SVG/logo.svg";
import { Icon } from "@iconify/react";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "@hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Header.module.scss";
import { Roles } from "~/Utils/Roles";
import { get } from "@services/api.service";
import { useNotification } from "~/Hooks/useNotification";
import { imageKey } from "~/Utils";
import cs from "classnames";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { Fade } from "react-awesome-reveal";

const { Text } = Typography;
const { useBreakpoint } = Grid;

export const Header = () => {
  const [searchText, setSearchText] = useState("");
  const { user, logout } = useAuth();
  const [profileDetails, setProfileDetails] = useState<{
    [key in string]: string;
  }>({});
  const [, setUser] = useLocalStorage("user", {});
  const { lg, md, xs } = useBreakpoint();
  const { openToast } = useNotification();
  const navigate = useNavigate();
  const extras = useRef<HTMLDivElement>(null);
  const searchBar = useRef<InputRef>(null);
  const [activeMenuItem, setActiveMenuItem] = useState("");
  const [activeMenuIndex, setActiveMenuIndex] = useState(-1);
  const { pathname, hash } = useLocation();

  const menuItems: any = [
    { text: "DECARB PROJECTS HUB", link: "/dashboard#investment-hub" },
    // { text: "Investment Across ASEAN", link: "/dashboard#investment-asean" },
    { text: "Sustainable Finance Framework", link: "/dashboard#sustainable-finance-framework" },
    { text: "Decarb Tools Hub", link: "/dashboard#esg-hub" },
    // { text: "Infratech Marketplace", link: "/dashboard#infratech-marketplace" },
    { text: "Knowledge Hub", link: "/knowledge-hub" },
    { text: "Gallery", link: "/gallery" },
  ];

  const handleMenuClick = (index: number) => {
    setActiveMenuIndex(index);
    let link = menuItems[index].link;
    // if(link === "/esg-hub"){

    // }else{
    navigate(link);
    // }
  };

  useEffect(() => {
    const activeIndex = menuItems.findIndex(
      (item: any) => pathname?.split("/")[1] === item.link?.split("/")[1]
    );
    setActiveMenuIndex(activeIndex);
    scrollToTop();
  }, [pathname]);

  const scrollToTop = () => {
    setTimeout(() => {
      let element: any = document.getElementById("app-layout-content");
      if (element) {
        element.scroll({ top: 0, left: 0, behavior: "smooth" });
      }
    }, 0);
  };

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const activeIndex = menuItems.findIndex((item: any) =>
          item.link.includes(hash)
        );
        setActiveMenuIndex(activeIndex);
        let temp = hash.replace("#", "");
        const element: any = document.getElementById(temp);
        element.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      scrollToTop();
    }
  }, [hash]);

  return (
    <Layout.Header
      className={cs(styles.header, {
        [styles.SmallHeader]: xs,
      })}
    >
      <Row justify="space-between" align="middle" style={{ height: "100%" }}>
        <Col span={6} className={styles.logoStyle}>
          <div className="align-center">
            <Image
              src={logo}
              preview={false}
              style={{
                maxWidth: 180,
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/dashboard");
              }}
            />
            <Divider
              type="vertical"
              style={{
                height: 30,
                border: "1px solid #9D9D9C",
                margin: "0 20px",
              }}
            />
            <Typography.Title
              level={4}
              style={{ color: styles.primary, marginBottom: 0 }}
            >
              PLATFORM FUSION
            </Typography.Title>
          </div>
        </Col>
        <Col span={18} style={{ textAlign: "right", userSelect: "none" }}>
          <div style={{ width: "100%" }} className="flex-center">
            <div
              className="flex-center"
              style={{ maxWidth: 900, width: "100%" }}
            >
              {menuItems.map((item: any, index: number) => (
                <Typography.Link
                  key={index}
                  // href={item.link}
                  style={{
                    cursor: "pointer",
                    fontSize: 12,
                    color: index === activeMenuIndex ? "#FD349C" : "#003087",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    paddingLeft: 4,
                    paddingRight: 4,
                  }}
                  onClick={() => handleMenuClick(index)}
                >
                  <span
                    style={{
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    {item.text}
                    {index === activeMenuIndex && (
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          left: 0,
                          width: "40%",
                          height: "3px",
                          backgroundColor: "#00B8F5",
                        }}
                      />
                    )}
                  </span>
                </Typography.Link>
              ))}
            </div>
            <div>
              <Button
                type="primary"
                className="btn-primary"
                style={{
                  borderRadius: "36px !important",
                  height: 32,
                }}
                onClick={() => navigate("/auth/login")}
              >
                LOGIN
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Layout.Header>
  );
};
